/* eslint-disable no-undef */
import React from 'react';
import { observable, action } from 'mobx';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';
import NumberFormat from 'react-number-format';
import { Utils } from 'Utils/utils';
import { userDetail } from 'Stores/userDetail';
import HubspotForm from 'react-hubspot-form';
import * as CONSTANTS from 'Utils/constants';
import { ReactComponent as CloseIcon } from '../../../assets/svg/close-material.svg';
import PopupBgLineIcon from '../../../assets/png/popupBgline.png';
import { LoadingWrapper } from './loadingWrapper';
import Button from './Button';

class TrialFormPopupState {
  @observable showTrialUpgradeForm = false;

  @action
  setShowTrialUpgradeForm(val = false) {
    this.showTrialUpgradeForm = val;
  }
}
const trialFormPopupState = new TrialFormPopupState();

const TrialUpgradeFormPopup = observer(props => {
  const [
    showFormSubmissionMessage,
    setShowFormSubmissionMessage,
  ] = React.useState(false);

  // const [showClose, setShowClose] = React.useState(true);

  const closePopup = () => {
    Utils.removeBusinessEmailFromUrl();
    trialFormPopupState.setShowTrialUpgradeForm(false);
  };

  const hubspotSuccessCallback = (formData = []) => {
    // setShowClose(false);

    Utils.mixpanelTrack(
      CONSTANTS.MX_TRIAL_ONBOARDING.CLICK_LB_TRIAL_UPGRADE_NOW_FORM_FILL,
      {},
    );
    setShowFormSubmissionMessage(true);
  };

  const scheduleDemo = () => {
    Utils.mixpanelTrack(
      CONSTANTS.MX_TRIAL_ONBOARDING.CLICK_LB_TRIAL_SCHEDULE_CALL,
      {},
    );
    window.open(userDetail.hubspotCalendarLink, '_blank');
    setShowFormSubmissionMessage(false);
    closePopup();
  };

  const closeSubmissionMsgPopup = () => {
    setShowFormSubmissionMessage(false);
    closePopup();
  };

  const handleSubmissionCloseClick = () => {
    // setShowFormSubmissionMessage(false);
    trialFormPopupState.setShowTrialUpgradeForm(false);
  };

  const FormSubmissionMsg = () => {
    return (
      <>
        <div className="confirmation-popup common-popup trial-upgrade-hubspot-success-popup">
          <div className="popup-wrap">
            <div
              className="popup-close"
              title="Click here to close"
              onClick={e => closeSubmissionMsgPopup(e)}
            >
              <CloseIcon />
            </div>
            <div className="popup-content-wrap">
              <div className="title">{`Let's find the right plan for you. Pick a time to talk to one of our experts to 
              upgrade.`}</div>

              <Button
                btnText="Schedule call"
                icon={false}
                iconName=""
                type="button"
                className="action-btn"
                click={e => scheduleDemo()}
              />
            </div>
          </div>
        </div>
        <div className="common-popup-mask" onClick={() => {}} />
      </>
    );
  };

  const HSFormWrapper = () => {
    return (
      <div className="hubspot-form">
        <HubspotForm
          portalId={CONSTANTS.HUBSPOT_PORTAL_ID}
          formId={CONSTANTS.SELF_TRIAL_UPGRADE_HUBSPOT_FORM_ID}
          inlineMessage="Please select a comfortable time for our expert to help you with a custom plan."
          onSubmit={formData => {
            setTimeout(() => {
              hubspotSuccessCallback(formData);
            }, 250);
          }}
          onReady={form => {
            console.log('Form ready!');
            setTimeout(() => {
              Utils.removeBusinessEmailFromUrl();
            }, 500);
          }}
          loading={
            <div className="loading-icon">
              <LoadingWrapper show />
            </div>
          }
        />
      </div>
    );
  };

  return trialFormPopupState.showTrialUpgradeForm ? (
    <>
      {showFormSubmissionMessage ? (
        <FormSubmissionMsg />
      ) : (
        <div
          className={`pricingPopup common-popup${
            trialFormPopupState.showTrialUpgradeForm
              ? ' pricingHubSpotForm'
              : ''
          }`}
        >
          <div className="pricing-popup-overlay" onClick={e => closePopup()} />
          <div className="pricing-popup">
            <img
              className="bg-line"
              src={PopupBgLineIcon}
              alt="Popup bg icon"
            />

            {/* {showClose && (
              <span className="close-popup" onClick={e => closePopup()}>
                <CloseIcon />
              </span>
            )} */}

            <HSFormWrapper />
          </div>
        </div>
      )}
    </>
  ) : (
    ''
  );
});

const TrialFormPopup = observer(props => {
  return (
    <>
      {trialFormPopupState.showTrialUpgradeForm && (
        <TrialUpgradeFormPopup {...props} />
      )}
    </>
  );
});

export { TrialFormPopup, trialFormPopupState };
export default TrialFormPopup;
